import { Fragment } from "react";

const SectionTitle = ({
  title,
  countValue = 34500,
  
 
  bg,
}) => {
  return (
    <Fragment>
      <h2>{title}</h2>
      
    </Fragment>
  );
};
export default SectionTitle;
